import { render } from "./OneVideo.vue?vue&type=template&id=56645fe3&scoped=true"
import script from "./OneVideo.vue?vue&type=script&lang=js"
export * from "./OneVideo.vue?vue&type=script&lang=js"

import "./OneVideo.vue?vue&type=style&index=0&id=56645fe3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56645fe3"]])

export default __exports__